import React, { FC } from 'react';
import { useLocation } from 'react-router';

import { CartDesktop } from 'src/components/cart/desktop/cart-desktop';
import { CartMobile } from 'src/components/cart/mobile/cart-mobile';
import { NavigationService } from 'src/services/navigation-service';
import { selectIsCartPopulated } from 'src/state/cart/selectors';
import { useAppSelector } from 'src/state/thunk-api';
import { useLargeTabletMediaQuery } from 'src/utils/breakpoints-utils';

export const CartInformation: FC = () => {
  const isCartNotEmpty = useAppSelector(selectIsCartPopulated);
  const path = useLocation().pathname;

  const isOnLargeTablet = useLargeTabletMediaQuery();

  if ([NavigationService.SUMMARY, NavigationService.SUCCESS].includes(path) || (!isOnLargeTablet && !isCartNotEmpty)) {
    return null;
  }

  return isOnLargeTablet ? <CartDesktop /> : <CartMobile />;
};
